// Countdown de campaña: parsea data-end ("AAAA-MM-DD HH:MM", hora LOCAL del
// navegador), tick de 1s y al expirar aplica data-end-behavior:
// hide = oculta la sección entera, message = swap dígitos → mensaje.
// Liquid no sabe si la fecha ya pasó (caché), así que todo se resuelve acá.
(function () {
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function init(root) {
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})[ T](\d{1,2}):(\d{1,2})$/.exec(root.getAttribute('data-end') || '');
    if (!m) return; // fecha vacía o inválida: queda el fallback estático (heading + CTA)

    // ponytail: hora local del navegador, suficiente para tiendas Chile;
    // si algún día hay campañas multi-zona, mover a timestamp UTC en data-end.
    var end = new Date(+m[1], m[2] - 1, +m[3], +m[4], +m[5]).getTime();
    var timer = root.querySelector('[data-infy-countdown-timer]');
    var slots = {
      days: root.querySelector('[data-days]'),
      hours: root.querySelector('[data-hours]'),
      minutes: root.querySelector('[data-minutes]'),
      seconds: root.querySelector('[data-seconds]')
    };

    function render(diff) {
      var s = Math.floor(diff / 1000);
      slots.days.textContent = pad(Math.floor(s / 86400));
      slots.hours.textContent = pad(Math.floor(s / 3600) % 24);
      slots.minutes.textContent = pad(Math.floor(s / 60) % 60);
      slots.seconds.textContent = pad(s % 60);
    }

    function expire() {
      if (root.getAttribute('data-end-behavior') === 'hide') {
        (root.closest('.shopify-section') || root).style.display = 'none';
        return;
      }
      timer.hidden = true;
      var message = root.querySelector('[data-infy-countdown-message]');
      if (message) message.hidden = false;
    }

    var diff = end - Date.now();
    if (diff <= 0) {
      expire();
      return;
    }

    render(diff);
    timer.hidden = false;

    var id = setInterval(function () {
      var left = end - Date.now();
      if (left <= 0) {
        clearInterval(id);
        expire();
        return;
      }
      render(left);
    }, 1000);
  }

  document.querySelectorAll('[data-infy-countdown]').forEach(init);
})();
